import { css } from 'src/styles/theme';

export const StylesAP = css``;
